import { emptyCountrySplit, PricingModels } from '../../quotes/constants';
import { getDefaultGenderShare } from './get-default-gender-shares';
import getId from './get-id';

const hasPercentFeeModel = (product, opportunity) =>
  product[`defaultPriceModel${opportunity.campaignObjective}`] ===
  PricingModels.FEE_PERCENT;

const getDefaultFee = (product, opportunity) =>
  hasPercentFeeModel(product, opportunity) ? product.defaultPrice : 0;

export default function initializeQuoteLineFrom(
  quote,
  product,
  opportunity,
  lineNumber = -1,
) {
  const defaultFee = getDefaultFee(product, opportunity);
  return {
    id: getId(),
    productId: product.id,
    quoteId: quote.id,
    lineNumber,
    netClientBudget: 0,
    netClientBudgetExternal: 0,
    wkzBudget: 0,
    coInvest: 0,
    freeService: 0,
    countrySplit: emptyCountrySplit,
    pricing: product[`defaultPriceModel${opportunity.campaignObjective}`],
    originalFee: defaultFee,
    adjustedFee: defaultFee,
    startDate: null,
    endDate: null,
    genders: [],
    ...getDefaultGenderShare(product),
    categories: [],
    created: '',
    lastModified: '',
    createdBy: '',
    lastModifiedBy: '',
    isPartOfCommercialPackage: !!opportunity?.commercialPackage,
  };
}
